import React from "react";
import "gatsby-plugin-breadcrumb/gatsby-plugin-breadcrumb.css";
import { QueryClientProvider } from "react-query";
import { queryClient } from "./src/utils/endpoint";
import { LanguageProvider } from "./src/utils/contexts/languageContext";
import { AuthProvider } from './src/utils/contexts/authContext';

export const wrapPageElement = ({ element, props }) => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <AuthProvider>
        {element}
      </AuthProvider>
    </LanguageProvider>
  </QueryClientProvider>
);
